<template>
  <div class="logo-container" v-if="redirection">
    <img alt="PayJoy Logo" class="pj-mobile-logo" :src="logoImage" />
  </div>
  <router-link v-else :to="routeLocation">
    <img alt="PayJoy Logo" class="pj-mobile-logo" :src="logoImage" />
  </router-link>
</template>

<script setup lang="ts">
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { computed } from "vue";
import { getCountryCode } from "@/apps/merchant3/helpers/country";

const props = defineProps({
	routeName: {
		type: String,
	},
	redirection: {
		default: false,
		type: Boolean,
	},
	darkTheme: {
		default: false,
		type: Boolean,
	},
});
const logoImage = computed(() => {
	return props.darkTheme
		? useAsset("img/logo_bg_black.svg")
		: useAsset("img/logo_bg_white.svg");
});
const routeLocation = computed(() => ({
	name: props.routeName,
	params: { countryCode: getCountryCode() },
}));
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
div.logo-container {
  display: inline;
}
</style>
